import MuiDivider from '@mui/material/Divider';
import Typography, { type TypographyProps } from '@mui/material/Typography';

import styles from './divider.module.scss';

type Props = {
  className?: string;
  startText?: string;
  endElement?: React.JSX.Element;
  variant?: TypographyProps['variant'];
};

const Divider = ({ className, startText, endElement, variant }: Readonly<Props>): React.JSX.Element => (
  <div className={`${styles.dividerContainer} ${className ?? ''}`}>
    {startText && (
      <Typography className={styles.startText} variant={variant ?? 'h5'}>
        {startText}
      </Typography>
    )}
    <MuiDivider />
    {endElement}
  </div>
);

export default Divider;
